import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpdocumentComponent } from '../empdocument/empdocument.component';
import { AdddocumentComponent } from './adddocument/adddocument.component';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { AdddocumentdetailsComponent } from './adddocumentdetails/adddocumentdetails.component';
import { DocumentviewerComponent } from './documentviewer/documentviewer.component';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent implements OnInit {

  
  @Input() formname: string = "";

  @Input() trxtype: string = "";
  @Input() trxid: number = 0;
  @Input() mode: string="";

  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();
  
  documentColl: any = [];

  constructor(private toastr: ToastrService,private appService: AppdataService,private datePipe: DatePipe,
    private loginService: LoginserviceService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal) {
    
       
 
   }

  ngOnInit() {

    this.fnGetDocument();        
        

  }


  fnGetDocument() {
   
    var data = {
      'trxid': this.trxid,
      'trxtype': this.trxtype,     
    }


    this.appService.fngetDocument(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          var result = res.json().result;
          console.log(result);

          var docColl = result[0];
          var docdetailsColl = result[1];
       
          this.documentColl = [];

          for (let abo of docColl) {
            
            let detailsColl = [];

            for (let dbo of docdetailsColl) { 
              if (this.fnGetDocumentId(dbo) === this.fnGetDocumentId(abo) ) {
                detailsColl.push(dbo);
              }             
            }

            abo.docdetailsColl = detailsColl;

            this.documentColl.push(abo);
          }

        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
      
  }


  fnAddDocument() {
    const modalRef = this.productFindService.open(AdddocumentComponent ,{ size: <any> 'l'  });
    
    modalRef.componentInstance.trxtype = this.trxtype;
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnInsertDocument(receivedEntry);    
      
    });
  }


  fnInsertDocument(reqdata) {
    

    var data = {
      'trxid': this.trxid,
      'trxtype': this.trxtype,
      'doctypeid': reqdata.doctypeid,
      'docnum':reqdata.docnum,
      'issuedt':this.fnFormatDatetime(reqdata.issuedt),
      'expirydt': this.fnFormatDatetime(reqdata.expirydt),
      'descr': reqdata.descr,
      'inactive': reqdata.inactive,
      'modifiedby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnInsertDocument(data).subscribe(
      (res) => {
        if (res.json().status === 200) {

          this.fnInsertActivityLog('INSERT',this.trxid,"DOCUMENT"+" - "+reqdata.doctypeid);
          this.fnGetDocument();
          
          // if (res.json().result != "") {
            
          // }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
    
    
  }



  
  fnAddDocumentDetails(reqdata) {
    const modalRef = this.productFindService.open(AdddocumentdetailsComponent ,{ size: <any>'l'  });
    
    modalRef.componentInstance.documentid = this.fnGetDocumentId(reqdata);
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnInsertDocumentDetails(receivedEntry);          
    });
  }
  

  fnInsertDocumentDetails(reqdata) {
    var data = {
      'trxid': reqdata.documentid,
      'trxtype': this.trxtype,
      'doctype': reqdata.doctype,
      'docstrimage':reqdata.docstrimage,
      'createdby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnInsertDocumentDetails(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fnGetDocument();

          this.fnInsertActivityLog('INSERT',this.trxid,"DOCUMENTFILES"+" - "+reqdata.documentid);
          // if (res.json().result != "") {
            
          // }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
    
    
  }


  fnViewDocumentDetails(documentBO) {
    const modalRef = this.productFindService.open(DocumentviewerComponent ,{ size: <any>'m'  });
    modalRef.componentInstance.trxtype = this.trxtype;
    modalRef.componentInstance.documentdetailsBO = documentBO;

    modalRef.componentInstance.fnSetDocument();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fnGetDocument();
    });
  }


  fnEditDocumentDetails(reqdata) {
    const modalRef = this.productFindService.open(AdddocumentComponent ,{ size: <any>'m'  });
    
    modalRef.componentInstance.documentid = this.fnGetDocumentId(reqdata);
    modalRef.componentInstance.doctypeid = reqdata.doctypeid;
    modalRef.componentInstance.docnum = reqdata.docnum;
    modalRef.componentInstance.issuedt=this.fnConvertDatetime(this.fnFormatDatetime(reqdata.issuedt));
    modalRef.componentInstance.expirydt=this.fnConvertDatetime(this.fnFormatDatetime(reqdata.expirydt));
    modalRef.componentInstance.descr = reqdata.descr;
    modalRef.componentInstance.inactive = reqdata.inactive;
    
    modalRef.componentInstance.trxtype = this.trxtype;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnSetDocument(receivedEntry);          
    });
  }


  
  fnSetDocument(reqdata) {
    
   

    var data = {
      'trxdocumentid': reqdata.documentid,
      'trxid': this.trxid,
      'trxtype': this.trxtype,
      'doctypeid': reqdata.doctypeid,
      'docnum':reqdata.docnum,
      'issuedt':this.fnFormatDatetime(reqdata.issuedt),
      'expirydt': this.fnFormatDatetime(reqdata.expirydt),
      'descr': reqdata.descr,
      'inactive': reqdata.inactive,
      'modifiedby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnSetDocumentv(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fnInsertActivityLog('EDIT',this.trxid,"DOCUMENT"+" - "+reqdata.documentid);
          this.fnGetDocument();
          // if (res.json().result != "") {
            
          // }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
    
    
  }


  public fnDeleteConfirm(reqdata) {
    try{
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete file?')
      .then((confirmed) => 
            {
              if(confirmed){
                this.fnDeleteDocument(reqdata)
              }          
          }        
      );     
      //.catch(() => );
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }



  fnDeleteDocument(reqdata) {
    var data = {
      'trxid': this.fnGetDocumentId(reqdata),
      'trxtype': this.trxtype,      
    }


    this.appService.fnDeleteDocument(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fnInsertActivityLog('DELETE', this.trxid,"DOCUMENT"+" - "+this.fnGetDocumentId(reqdata));
          this.fnGetDocument();
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });
    
    
  }

  fnGetDocumentId(reqdata) {
    if (this.trxtype === 'COMPANY') {
      return reqdata.companydocumentid;
    }
    else if (this.trxtype === 'BRANCH') {
      return reqdata.branchdocumentid;
    }
    else if (this.trxtype === 'ASSET') {
      return reqdata.assetdocumentid;
    }
    else if (this.trxtype === 'EMPLOYEE') {
      return reqdata.empdocumentid;
    }
  }


  fnDocumentRowClick(aBO) {
    
    if (aBO) {
      aBO.isopened = !aBO.isopened;    
    }
  }
  
  
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }

  fnConvertDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        var dateParts = dt.split("-");
        var sdate =new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]+1); 
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
      
      }else {
      return null
    }
   
  }
  
  
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
  
  

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
